import { createContext } from 'react';
import { Tooltip } from '@mui/material';
import { isUserEmployee } from 'utilities/utils';

// True when the subtree is being rendered inside this tooltip's popover.
// Consumers can opt in to render behavior (data fetches, full content)
// that only makes sense when popped, and short-circuit otherwise.
// Default false.
export const HoverCardContext = createContext(false);

const TOOLTIP_SLOT_PROPS = {
  tooltip: {
    sx: {
      bgcolor: 'transparent',
      p: 0,
      maxWidth: 'none',
      boxShadow: 'none',
      // MUI's default tooltip slot sets fontSize ~11px; reset to inherit
      // so the popover text reads at the surrounding document's size.
      fontSize: 'inherit',
    },
  },
  popper: {
    modifiers: [
      {
        name: 'flip',
        options: {
          fallbackPlacements: ['left-start', 'top-start', 'bottom-start'],
        },
      },
    ],
  },
};

export default function HoverCardTooltip({
  title,
  children,
  placement = 'right-start',
  enterDelay = 300,
  leaveDelay = 200,
}) {
  if (!isUserEmployee() || !title) {
    return children;
  }

  return (
    <Tooltip
      title={
        <HoverCardContext.Provider value>{title}</HoverCardContext.Provider>
      }
      placement={placement}
      enterDelay={enterDelay}
      leaveDelay={leaveDelay}
      slotProps={TOOLTIP_SLOT_PROPS}
    >
      {children}
    </Tooltip>
  );
}
